import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        CustomParagraphModule: {
          module: () => import('./custom-paragraph-lazy.module').then((m) => m.CustomParagraphLazyModule),
          cmsComponents: [SdvorSharedCmsComponents.CMSParagraphComponent],
        },
      },
    }),
  ],
})
export class CustomParagraphModule {}
